import React, { useState, useEffect } from 'react';
import '../../../urunDiv.css';
import '../sicak-kahveler/KahveDetay.css';
import damlaSakizliTurkKahvesi from '../../../../assets/menu/icecekler/turk-kahveleri.png';

const DamlaSakizliTurkKahvesi = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const kahve = {
    name: 'Damla Sakızlı Türk Kahvesi',
    price: '₺139,90',
    image: damlaSakizliTurkKahvesi,
    description: 'Damla sakızlı Türk kahvesi, özel sakız aroması ile...'
  };

  return (
    isPhone ? (
      <div className="americano-detay-container">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={kahve.image} alt={kahve.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{kahve.name} - {kahve.price}</div>
            </div>
          </div>
          
          <div className="product-description">
            <p>{kahve.description}</p>
          </div>
        </div>
      </div>
    ) : (
      <div className="urun-detay-container-computer">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={kahve.image} alt={kahve.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{kahve.name} - {kahve.price}</div>
            </div>
          </div>
          
          <div className="product-description-computer">
            <p>{kahve.description}</p>
          </div>
        </div>
      </div>
    )
  );
};

export default DamlaSakizliTurkKahvesi;
